import configEnv from "@/enums/configEnv";
import ServerType from "@/enums/serverType";

const getLangAbbr = {
  methods: {
    getLangAbbr(item) {
      if (configEnv.server_type === ServerType.BlueCross) {
        return item.lang;
      }
      return item.lang === 'en' ? null : item.lang
    },
  },
};

export default getLangAbbr;
